import { formatter } from '../../../../src/javascript/phoneNumberFormatter.js';

const initGuestPhoneInput = input => {
  const errorMessage = document.querySelector(`#${input.id}_error_msg`);
  formatter(input, errorMessage);
};

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('#certificationRequiredCheck');
  const submitButton = document.querySelector('.subscription-submit-btn');

  if (checkbox && submitButton) {
    submitButton.disabled = !checkbox.checked;

    checkbox.addEventListener('change', function () {
      submitButton.disabled = !checkbox.checked;
    });
  } else {
    console.error('Checkbox or submit button not found.');
  }

  document.querySelectorAll('.guestPhoneNumber').forEach(initGuestPhoneInput);

  // Guest info dynamic fields
  const guestsContainer = document.getElementById('guests-container');
  const addGuestBtn = document.getElementById('add-guest-btn');
  const guestTemplate = document.getElementById('guest-template');

  if (guestsContainer && addGuestBtn && guestTemplate) {
    let guestIndex = parseInt(guestsContainer.dataset.guestCount || 0);

    addGuestBtn.addEventListener('click', function () {
      const template = guestTemplate.innerHTML.replace(/INDEX_PLACEHOLDER/g, guestIndex);
      guestsContainer.insertAdjacentHTML('beforeend', template);
      const newInput = document.querySelector(`#subscription_guest_info_${guestIndex}_phone`);
      if (newInput) initGuestPhoneInput(newInput);
      guestIndex++;
    });

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('remove-guest-btn')) {
        e.target.closest('.guest-block').remove();
      }
    });
  }
});